<section class="content-section">
  <div style="margin-bottom: 24px; display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 12px;">
    <a [routerLink]="'/tarif/configuration/lister'" class="btn btn-secondary" style="display: inline-flex; align-items: center; gap: 8px;">
      ← Retour à la liste
    </a>
    <div class="mode-badge" [class.view]="!estModeEdition && tarifConfigurationForm.value.id" [class.edit]="estModeEdition || !tarifConfigurationForm.value.id">
      <span>{{ (!estModeEdition && tarifConfigurationForm.value.id) ? '🔒 MODE LECTURE' : '✏️ MODE ÉDITION' }}</span>
    </div>
  </div>

  <!-- VIEW MODE: Read-only display -->
  <ng-container *ngIf="!estModeEdition && tarifConfigurationForm.value.id">
    <div class="view-mode-container">
      <div class="form-section">
        <h3 class="form-section-title">Mode de Tarification</h3>
        <div class="info-box" style="background: #e0f2fe; border-left: 4px solid #0ea5e9; padding: 16px; border-radius: 8px; margin-bottom: 16px;">
          <h4 style="margin: 0 0 8px 0; color: #0c4a6e; font-size: 14px; font-weight: 600;">💡 Information</h4>
          <p style="margin: 0; color: #0369a1; font-size: 13px; line-height: 1.5;">
            La <strong>tarification par zone</strong> applique un montant forfaitaire selon les zones de départ et d'arrivée.
            Sinon, le tarif est calculé selon la distance parcourue.
          </p>
        </div>
        <div class="view-item">
          <label class="view-label">Mode de Tarification</label>
          <p class="view-value">
            <span class="badge" [class.badge-success]="tarifConfigurationForm.value.flgTarifParZone" [class.badge-info]="!tarifConfigurationForm.value.flgTarifParZone">
              {{ tarifConfigurationForm.value.flgTarifParZone ? 'Tarification par Zone' : 'Tarification par Distance' }}
            </span>
          </p>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section-title">Paramètres Tarifaires</h3>
        <div class="view-item-row">
          <div class="view-item">
            <label class="view-label">Montant Forfait (FCFA)</label>
            <p class="view-value">{{ tarifConfigurationForm.get('montantForfait')?.value | number:'1.0-2' }} FCFA</p>
          </div>
          <div class="view-item">
            <label class="view-label">Poids Forfaitaire Maximum (KG)</label>
            <p class="view-value">{{ tarifConfigurationForm.get('poidsForfaitaireMax')?.value | number:'1.0-2' }} KG</p>
          </div>
        </div>
        <div class="view-item">
          <label class="view-label">Montant par KG Supplémentaire (FCFA)</label>
          <p class="view-value">{{ tarifConfigurationForm.get('montantParKgSup')?.value | number:'1.0-2' }} FCFA</p>
        </div>
      </div>

      <div class="form-section" *ngIf="tarifConfigurationForm.get('observations')?.value">
        <h3 class="form-section-title">Observations</h3>
        <div class="view-item">
          <label class="view-label">Remarques</label>
          <p class="view-value" style="white-space: pre-wrap;">{{ tarifConfigurationForm.get('observations')?.value || '—' }}</p>
        </div>
      </div>

      <div class="form-actions">
        <a [routerLink]="'/tarif/configuration/lister'" class="btn btn-secondary">Retour</a>
        <button type="button" class="btn btn-primary" (click)="estModeEdition = true">Modifier</button>
      </div>
    </div>
  </ng-container>

  <!-- EDIT MODE: Form -->
  <form class="form-container" [class.edit-mode]="estModeEdition || !tarifConfigurationForm.value.id" [formGroup]="tarifConfigurationForm" (ngSubmit)="onSubmit()" *ngIf="estModeEdition || !tarifConfigurationForm.value.id">
    <div class="form-section">
      <h3 class="form-section-title">Mode de Tarification</h3>
      <div class="info-box" style="background: #e0f2fe; border-left: 4px solid #0ea5e9; padding: 16px; border-radius: 8px; margin-bottom: 16px;">
        <h4 style="margin: 0 0 8px 0; color: #0c4a6e; font-size: 14px; font-weight: 600;">💡 Information</h4>
        <p style="margin: 0; color: #0369a1; font-size: 13px; line-height: 1.5;">
          La <strong>tarification par zone</strong> applique un montant forfaitaire selon les zones de départ et d'arrivée.
          Sinon, le tarif est calculé selon la distance parcourue.
        </p>
      </div>
      <div class="form-group">
        <label class="checkbox-label" style="display: flex; align-items: center; gap: 12px; cursor: pointer;">
          <input type="checkbox" formControlName="flgTarifParZone" style="width: 18px; height: 18px; cursor: pointer;">
          <span style="font-size: 15px; font-weight: 500;">Activer la tarification par zone</span>
        </label>
      </div>
    </div>

    <div class="form-section">
      <h3 class="form-section-title">Paramètres Tarifaires</h3>
      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Montant Forfait (FCFA) *</label>
          <input
            type="number"
            class="form-input"
            [class.error]="tarifConfigurationForm.get('montantForfait')?.invalid && tarifConfigurationForm.get('montantForfait')?.touched"
            placeholder="Ex: 5000"
            formControlName="montantForfait"
            min="0"
            step="100">
          <span class="error-message" *ngIf="obtenirMessageErreur('montantForfait')">
            {{ obtenirMessageErreur('montantForfait') }}
          </span>
          <span style="color: var(--text-secondary); font-size: 12px; display: block; margin-top: 4px;">
            Montant de base de la livraison
          </span>
        </div>
        <div class="form-group">
          <label class="form-label">Poids Forfaitaire Maximum (KG) *</label>
          <input
            type="number"
            class="form-input"
            [class.error]="tarifConfigurationForm.get('poidsForfaitaireMax')?.invalid && tarifConfigurationForm.get('poidsForfaitaireMax')?.touched"
            placeholder="Ex: 5"
            formControlName="poidsForfaitaireMax"
            min="0"
            step="0.5">
          <span class="error-message" *ngIf="obtenirMessageErreur('poidsForfaitaireMax')">
            {{ obtenirMessageErreur('poidsForfaitaireMax') }}
          </span>
          <span style="color: var(--text-secondary); font-size: 12px; display: block; margin-top: 4px;">
            Poids maximum inclus dans le tarif forfaitaire
          </span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Montant par KG Supplémentaire (FCFA) *</label>
        <input
          type="number"
          class="form-input"
          [class.error]="tarifConfigurationForm.get('montantParKgSup')?.invalid && tarifConfigurationForm.get('montantParKgSup')?.touched"
          placeholder="Ex: 500"
          formControlName="montantParKgSup"
          min="0"
          step="50">
        <span class="error-message" *ngIf="obtenirMessageErreur('montantParKgSup')">
          {{ obtenirMessageErreur('montantParKgSup') }}
        </span>
        <span style="color: var(--text-secondary); font-size: 12px; display: block; margin-top: 4px;">
          Coût appliqué pour chaque kilogramme au-delà du poids forfaitaire
        </span>
      </div>
    </div>

    <div class="form-section">
      <h3 class="form-section-title">Observations (optionnel)</h3>
      <div class="form-group">
        <label class="form-label">Remarques</label>
        <textarea
          class="form-input"
          placeholder="Saisir les remarques ici ..."
          formControlName="observations"
          rows="4"></textarea>
        <span style="color: var(--text-secondary); font-size: 12px; display: block; margin-top: 4px;">
          Notes ou informations complémentaires sur cette configuration
        </span>
      </div>
    </div>

    <div class="form-actions">
      <a [routerLink]="'/tarif/configuration/lister'" class="btn btn-secondary">Annuler</a>
      <button type="submit" class="btn btn-primary" [disabled]="chargement || tarifConfigurationForm.invalid">
        @if (chargement) {
          ⏳ Enregistrement...
        } @else {
          {{ estModeEdition ? 'Enregistrer les modifications' : 'Enregistrer la configuration' }}
        }
      </button>
    </div>

    <app-spinner *ngIf="chargement"></app-spinner>
  </form>
</section>
